import { Grid } from '@mui/material'
import React from 'react'
import moment from 'moment';
import 'moment/locale/pt-br';
import { IoAlertCircleOutline } from "react-icons/io5";
import * as S from './style'
import { TokenContext } from "context/TokenContext";
import { useContext } from "react";

const InfluencerFinanceDetails = ({ entry }) => {
  moment.locale("pt-br")

  const { decodedToken } = useContext(TokenContext);
  const role = decodedToken?.type;

  return (
    <S.MainGrid container flexDirection='column' gap='15px'>
      <p style={{ fontSize: '24px' }}>Detalhes</p>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Valor(R$):</p>
          <p>{entry?.value ? Number((entry?.value / 100).toFixed(2)).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Projeto:</p>
          <p>{entry?.projectRelated ? entry?.projectRelated?.title : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Descrição:</p>
          <p>{entry?.description ? entry?.description : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85} sx={{ overflowWrap: 'break-word' }}>
          <p className='subTitle'>Conta Bancária:</p>
          <p>{entry?.bankAccount ? entry?.bankAccount : ''}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Data de fechamento:</p>
          <p>{entry?.dateInvoiced ? moment(entry?.dateInvoiced).format('L') : ''}</p>
        </Grid>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Data de pagamento:</p>
          <p>{entry?.paymentDate ? moment(entry?.paymentDate).format('L') : '-'}</p>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        {(role !== "INFLUENCER") && (
          <Grid item xs={12} md={5.85} xl={5.85}>
            <p className='subTitle'>Empresa:</p>
            {entry?.leadRelated ? entry?.leadRelated?.businessName : ''}
          </Grid>
        )}
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Marca:</p>
          {entry?.brand ? entry?.brand : ''}
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between'>
        <Grid container justifyContent='space-between'>
          <Grid item xs={12} md={5.85} xl={5.85}>
            <p className='subTitle'>Tipo de saldo:</p>
            <p>{entry?.type === 'CURRENT' ? 'Atual' : 'Futuro'}</p>
          </Grid>
          <Grid item xs={12} md={5.85} xl={5.85}>
            <p className='subTitle'>Status do saldo:</p>
            <p>{entry?.status === 'PENDING' ? 'Pendente' : 'Pago'}</p>
          </Grid>
        </Grid>
      </Grid>
      {role === "ADMINISTRATOR" && entry?.outboundRelated && (
        <Grid container justifyContent='space-between'>
          <Grid item xs={12} md={5.85} xl={5.85}>
            <p className='subTitle'>Despesa Relacionada:</p>
            <p className='wrap'>{entry?.outboundRelated?.description || ''}</p>
          </Grid>
        </Grid>
      )}
      <Grid container justifyContent='space-between'>
        <Grid item xs={12} md={5.85} xl={5.85}>
          <p className='subTitle'>Observações:</p>
          <p className='wrap'>{entry?.misc ? entry?.misc : ''}</p>
        </Grid>
      </Grid>
      <S.WarningGrid container gap='5px'>
        <IoAlertCircleOutline color='red' style={{ alignSelf: "center" }} />
        <p className='subtitle reminder'>Lembrete:</p>
        <p className='subtitle'>Este valor pode ser alterado até o dia do recebimento mensal.</p>
      </S.WarningGrid>
    </S.MainGrid>
  )
}

export default InfluencerFinanceDetails